/**
 * Query string parameter name where previous state is stored.
 */
export const STATE_QS_KEY = 'state';
